var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6492 4.67195H2V17.6947H2.81435L16.6492 4.67195Z",
    fill: "#FF0400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3008 17.2261H22.0011V7.01031L11.3008 17.2261Z",
    fill: "#FF0400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.933 4.10097L4.06999 18.0905L3.3125 18.7729L5.04584 20.6496L5.56448 20.1946L20.912 5.54315C21.3783 5.12233 21.7082 4.81978 21.7082 4.81978L20.0226 3L18.933 4.10097Z",
    fill: "#FF0400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94141 20.3675H15.9666V17.8767H10.5505L7.94141 20.3675Z",
    fill: "#FF0400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorOff);
export default __webpack_public_path__ + "static/media/monitor-off.271177c55805368d984cd4d7b594d857.svg";
export { ForwardRef as ReactComponent };